// ============================================================================
// view.sheepweighins — migrated off the global read
// ============================================================================
// The sheep weigh-in list owns its session census and paged, species-scoped
// entries through sheep.weighins.list. Saved views remain a nonblocking user
// preference sidecar and are not an obligation of the rendered list data.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.sheepweighins',
  obligations: Object.freeze([Object.freeze({id: 'sheep.weighins.list', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
